var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8File(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "40px",
    height: "40px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.5 14.5L2.5 0.5 9.867 0.5 13.5 4.204 13.5 14.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M9.657,1L13,4.409V14H3V1H9.657 M10.077,0H2v15h12V4L10.077,0L10.077,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.5 4.5L9.5 0.5 9.831 0.5 13.5 4.206 13.5 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M10,1.381L12.593,4H10V1.381 M10.04,0H9v5h5V4L10.04,0L10.04,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8File);
export default __webpack_public_path__ + "static/media/icons8-file.1f570228ded8a82d080c1f4a8915a904.svg";
export { ForwardRef as ReactComponent };